module.exports = __webpack_public_path__ + "img/e6906b1.jpg";